"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.b64DecodeUnicode = exports.b64EncodeUnicode = void 0;

/* global btoa, atob */

/**
 * Unicode safe encode
 * @see https://stackoverflow.com/questions/30106476
 * @param {string} str the string to encode
 * @return {string} an encoded version of str
 */
var b64EncodeUnicode = function b64EncodeUnicode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode(parseInt(p1, 16));
  })).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
};
/**
 * Unicode safe decode
 * @param {string} str the string to decode
 * @return {string} the decoded str
 */


exports.b64EncodeUnicode = b64EncodeUnicode;

var b64DecodeUnicode = function b64DecodeUnicode(str) {
  return decodeURIComponent(Array.prototype.map.call(atob(str.replace(/_/g, '/').replace(/-/g, '+')), function (c) {
    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));
};

exports.b64DecodeUnicode = b64DecodeUnicode;